const HowItWorks = () => {
  const steps = [
    {
      num: '01',
      icon: '🎙️',
      title: 'Capture',
      description:
        'Your live meeting is captured right on your machine—no bot dials in—and transcribed in real time through your own provider key.',
    },
    {
      num: '02',
      icon: '🪪',
      title: 'Identify',
      description:
        'Voiceprints attribute every line to a known person—so the transcript reads “Alek: ship the migration,” not “Speaker 2: …”.',
    },
    {
      num: '03',
      icon: '🤝',
      title: 'Hand off',
      description:
        'Speaker-aware tasks are routed to the right agent on your team, with the context of who asked and why.',
    },
    {
      num: '04',
      icon: '⚡',
      title: 'Act',
      description:
        'Your scheduled Claude agents execute—researching, drafting, coding, following up—and stream results back live.',
    },
  ];

  return (
    <section className="how" id="how-it-works">
      <div className="section-container">
        <p className="overline overline--center">HOW IT WORKS</p>
        <h2 className="section-title">From spoken word to finished work, on infrastructure you own</h2>
        <p className="section-subtitle">
          The differentiator isn’t any single step—it’s that all four live in one app you own
          outright, forming a loop nobody else closes end to end.
        </p>

        <ol className="how-steps">
          {steps.map((s, i) => (
            <li key={i} className="how-step">
              <div className="how-step-num mono">{s.num}</div>
              <div className="how-step-icon" aria-hidden="true">
                {s.icon}
              </div>
              <h3>{s.title}</h3>
              <p>{s.description}</p>
              {i < steps.length - 1 && (
                <span className="how-step-arrow" aria-hidden="true">
                  →
                </span>
              )}
            </li>
          ))}
        </ol>

        <div className="how-loopback mono" aria-hidden="true">
          ⟲ and the loop closes — every meeting feeds the team that acts on it
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
